<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="invocie-view">
        <b-modal ref="InvoiceEmailModal" v-model="showInvoiceEmailModal" size="lg" centered v-if="currentInvoice">
          <div slot="modal-header">
            <strong class="text-uppercase text-muted text-center">Send Invoice as Email</strong>
          </div>
          <b-row align-v="center">
            <b-col cols="12" lg="5">
              <div class="h5 text-muted my-4">
                <p v-if="agent">
                  Are you sure you want to send Invoice <strong>No: {{currentInvoice.receipt_id}}</strong> to <strong>{{agent.name}}</strong>?
                </p>
                <p v-else>
                  <strong class="text-danger">Agent has been deleted!</strong><br>
                  Do you still want to send the Invoice <strong>No: {{currentInvoice.receipt_id}}</strong>?
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="7">
              <div class="my-4">
                <div class="h6 text-muted">Email Body</div>
                <quill-editor id="InvoiceEdit-quill-editor" v-model="email.body" :options="customEditorOptions"></quill-editor>
              </div>
            </b-col>
          </b-row>
          <div slot="modal-footer">
            <b-button type="submit" variant="link" @click="showInvoiceEmailModal = false">
              <i class="fa fa-ban"></i> No Thanks
            </b-button>
            <b-button type="submit" variant="success" @click="sendInvoice">
              <i class="fa fa-dot-circle-o"></i> Yes Email
            </b-button>
          </div>
        </b-modal>

        <b-row class="my-2">
          <b-col class="text-right">
            <b-button type="generate" variant="success" @click="confirmSendInvoice">
              <i class="fa fa-dot-circle-o"></i> Send Invoice
            </b-button>
            <b-button type="reset" variant="danger" to="/invoices">
              <i class="fa fa-ban"></i> Cancel
            </b-button>
          </b-col>
        </b-row>
        <b-row class="my-4">
          <b-col>
            <div class="embed-responsive">
              <iframe class="embed-responsive-item" :src="invoiceUrl"></iframe>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../../axios'
import { mapGetters } from 'vuex'
import { invoiceServices } from '../../services'
import editorOptions from '@/editor'

export default {
  name: 'InvoiceEdit',
  props: ['id'],
  data () {
    return {
      isBusy: false,
      showInvoiceEmailModal: false,
      email: {
        body: ''
      },
      editorOptions: editorOptions
    }
  },
  computed: {
    ...mapGetters(
      'user',
      [
        'accessToken'
      ]
    ),
    ...mapGetters(
      'agents',
      [
        'agentById'
      ]
    ),
    ...mapGetters(
      'invoices',
      [
        'currentInvoice'
      ]
    ),
    invoiceUrl () {
      if (this.id) {
        return baseURL + 'invoice/' + this.id + '/print?token=' + this.accessToken
      } else {
        return null
      }
    },
    agent () {
      let agent = {}
      if (this.currentInvoice) {
        agent = this.agentById(this.currentInvoice.agent_id)
      }
      return agent
    },
    defaultEmailBody () {
      let content = []

      if (this.agent) {
        content.push('Dear ' + this.agent.name + ',')
      } else {
        content.push('To Whom it may concern,')
      }

      content.push('kindly find the attached invoice numbered: ' + this.currentInvoice.receipt_id)
      return content
    },
    defaultEmailBodyPlaceholder () {
      return this.defaultEmailBody.join('\n')
    },
    customEditorOptions () {
      return {
        ...editorOptions,
        placeholder: this.defaultEmailBodyPlaceholder
      }
    }
  },
  methods: {
    sendInvoice () {
      let xhr = invoiceServices.send(this.currentInvoice.id, {
        body: this.email.body || ('<p>' + this.defaultEmailBody.join('</p><p>') + '</p>')
      })

      xhr.then((res) => {
        this.showInvoiceEmailModal = false
        this.$store.dispatch('app/addSuccessLog', {
          origin: 'invoice/send',
          message: 'Invoice Sent via Email!',
          ...res
        })
      }).catch((e) => {
        this.showInvoiceEmailModal = false
        this.$store.dispatch('app/addErrorLog', {
          origin: 'invoices/send',
          ...e.response.data
        })
      })
    },
    confirmSendInvoice () {
      this.showInvoiceEmailModal = true
    },
    getAgentNameById (agentId) {
      let agent = this.agentById(agentId)
      return agent || {}
    }
  },
  created () {
    this.$store.dispatch('agents/index')
    this.$store.dispatch('invoices/show', this.id)
  }
}
</script>

<style scoped lang="scss">
  .embed-responsive {
    height: 69vh;
  }
</style>

<style lang="scss">
  #InvoiceEdit-quill-editor {
    .ql-container {
      min-height: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/invoices/View.vue